import { useState } from "react"
import { useAuth } from "@/contexts/AuthContext" // Ajuste o caminho conforme seu projeto
import { Company } from "@/types/company"
import { Button } from "../atoms"
import { useToast } from "@/hooks/useToast"
import { normalizeCalLink } from "@/utils/calendarize"
import CalendarizeEmbed from "./CalendarizeEmbed"

export default function CalendarBookingModal({
  company,
  onSuccess,
}: {
  company: Company
  onSuccess?: () => void
}) {
  const [copied, setCopied] = useState(false)
  const { user } = useAuth()
  const showToast = useToast()
  const calendarLink = normalizeCalLink(user.linkCalendarize)

  const handleCopyLink = async () => {
    if (!company.linkCalendarize) {
      showToast({
        message: "Link de agenda não disponível para esta empresa.",
        variant: "error",
      })
      return
    }

    try {
      await navigator.clipboard.writeText(company.linkCalendarize)
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 2000)
      showToast({
        message: "Link da agenda copiado com sucesso!",
        variant: "success",
      })
    } catch (err) {
      console.error("Falha ao copiar: ", err)
    }
  }

  return (
    <div className="h-[60vh] w-[60vw]">
      <div className="flex justify-end px-4">
        <Button
          onClick={handleCopyLink}
          icon="copy"
          size="sm"
          variant="outline"
        >
          Copiar link da agenda
        </Button>
      </div>
      <CalendarizeEmbed
        calLink={calendarLink}
        config={{
          "emp-id": String(company.empId),
          "emp-name": company.nomeFantasia,
          name: company.nomeFantasia,
          email: company.emailEmpresa,
        }}
        onSuccess={onSuccess}
        emptyMessage="Link de agendamento não configurado para este usuário."
      />
    </div>
  )
}
